import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Row, Col, Button, Table, Alert, Spinner } from "react-bootstrap";
import { selectUser } from "../../features/userSlice";
import { useNavigate } from 'react-router-dom';

const PostGST2bData = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const token = user?.token;
  const emp_id = user?.emp_id;

  const [pendingBatches, setPendingBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [posting, setPosting] = useState(false);
  const [postingRow, setPostingRow] = useState(null);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // =======================================
  // Load Pending Batches on Page Load
  // =======================================
  const loadPendingBatches = async () => {
    try {
      setLoading(true);
      setErrorMsg("");
      setSuccessMsg("");

      const res = await axios.post("/api/gst2b/getPendingBatchesForUpload", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setPendingBatches(res.data || []);
      console.log(pendingBatches);
    } catch (err) {
      console.error("Error loading pending batches", err);
      setErrorMsg("Failed to load pending batches");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPendingBatches();
  }, []);

  // =======================================
  // POST GST2B → Call Backend Procedure
  // =======================================
  const postGST2b = async (batch) => {
    try {
      //setPosting(true);
      setPostingRow(batch.BATCH_ID);  // <-- set only this row as posting
      setErrorMsg("");
      setSuccessMsg("");

      const payload = {
        batch_no: batch.BATCH_ID,
        period: batch.GSTR2B_PERIOD,
        file_name: batch.FILE_NAME,
        fy: batch.GSTR2B_PERIOD,
        posted_by: batch.UPLOADED_BY,
      };

      const res = await axios.post(
        "/api/gst2b/postGST2bFromStage",
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setSuccessMsg(res.data?.message || "GST2B Posted Successfully!");

      // Refresh grid
      loadPendingBatches();
    } catch (err) {
      console.error("Post GST2B Error:", err);
      setErrorMsg(
        err.response?.data?.message || "Failed to post GST2B data"
      );
    } finally {
      //setPosting(false);
      setPostingRow(null);   // clear posting row
    }
  };

  if (!token) {
    return (
      <div>
        <p>You must be logged in to print daily attendance.</p>
        <button onClick={() => navigate("/")}>Go to Login</button>
      </div>
    );
  }
 
  return (
    <div className="container mt-3">

      <h4 className="text-primary">Post GST-2B Data</h4>

      {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
      {successMsg && <Alert variant="success">{successMsg}</Alert>}

      {loading ? (
        <div className="text-center mt-3">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <h5 className="mt-3">Pending Batches</h5>

          {pendingBatches.length === 0 ? (
            <Alert variant="info">No pending batches to post.</Alert>
          ) : (
            <Table bordered hover responsive size="sm" className="mt-2">
              <thead>
                <tr>
                  <th>Batch No</th>
                  <th>Period</th>
                  <th>Entity</th>
                  <th>FY</th>
                  <th>Uploaded By</th>
                  <th>Uploaded On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {pendingBatches.map((b, idx) => (
                  <tr key={idx}>
                    <td>{b.BATCH_ID}</td>
                    <td>{b.GSTR2B_PERIOD}</td>
                    <td>{b.FILE_NAME}</td>
                    <td>{b.GSTR2B_PERIOD}</td>
                    <td>{b.UPLOADED_BY}</td>
                    <td>{b.UPLOAD_TIMESTAMP}</td>
                    <td>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => postGST2b(b)}
                        //disabled={posting}
                        disabled={postingRow === b.BATCH_ID}   // disable only this row’s button
                      >
                          {postingRow === b.BATCH_ID ? (
                            <Spinner size="sm" />
                          ) : (
                            "POST GST2B"
                          )}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </>
      )}
    </div>
  );
};

export default PostGST2bData;
